import { CheckCircle2 } from 'lucide-react';

interface PublicOrderPaidAlertProps {
  open: boolean;
}

export function PublicOrderPaidAlert({ open }: PublicOrderPaidAlertProps) {
  if (!open) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="animate-in fade-in slide-in-from-top-2 duration-300"
    >
      <div className="flex items-center gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 shadow-sm">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-500">
          <CheckCircle2 className="h-5 w-5 text-white" strokeWidth={2.5} />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-emerald-900">អ្នកបានទូទាត់រួចរាល់</p>
          <p className="text-xs text-emerald-700/80">Payment completed successfully</p>
        </div>
      </div>
    </div>
  );
}
